import { React, useState } from "react";

const headersData = [
    { path: '', linkName: 'Home'},
    { path: 'Rental', linkName: 'Rental'},
    { path: 'Mircea', linkName: 'Mircea'},
];

export default function Header(props) {

  const [currentUrl, setCurrentUrl] = useState("/");

  const isSelected = (currentPath) => {
    if (currentPath == '')
    {
        if (currentUrl == '/')
        {
            return "option-selected";
        }
    }
    else if (currentUrl.includes(`/${currentPath}`)) 
    {
      return "option-selected-"+currentPath;
    }
  }

  if (window.location.pathname !== currentUrl)
  {
    setCurrentUrl(window.location.pathname);
  }
  
  return (
    <div className="full-width sticky top-0 z-50 bg-slate-950 shadow-2xl before:content-[''] before:fixed before:top-0 before:h-[1px] before:w-full before:bg-slate-950">
        <div className="flex flex-row items-center justify-center">
          {headersData.map((header, index) => (
            <div className="ms-8 me-8 md:text-2xl font-bold pt-8 pb-8">
              <a href={`/${header.path}`} key={`header-${index}`}>
                <div>
                  <h2 className={`${isSelected(header.path)}`}>{header.linkName.toUpperCase()}</h2>
                </div>
              </a>
              {/* index < headersData.length - 1 && (
                <div><img alt="" src={getSeparator()} /></div>
              )*/}
            </div>
          ))}
        </div>
    </div>
  );
}